import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, FileText, Home, MessageCircle, Award, Gift } from 'lucide-react';
const bonuses = [{
  icon: FileText,
  title: 'Manual de Símbolos Energéticos',
  price: '$5.000',
  desc: 'Guía completa de geometría sagrada y símbolos de poder para potenciar tus sesiones.'
}, {
  icon: Home,
  title: 'Limpieza Energética del Hogar',
  price: '$5.000',
  desc: 'Protocolos exactos para purificar espacios y mantener una alta vibración en tu entorno.'
}, {
  icon: MessageCircle,
  title: 'Afirmaciones y Decretos',
  price: '$5.000',
  desc: 'Poderosas programaciones verbales cuánticas para acelerar la manifestación.'
}, {
  icon: Award,
  title: 'Certificado Profesional',
  price: '$5.000',
  desc: 'Plantilla editable premium para avalar tus conocimientos y entregar a tus consultantes.'
}];
export function Bonuses() {
  return <section className="py-16 relative z-10 bg-[#130b29]" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#fbbf24]/10 border border-[#fbbf24]/30 text-[#fbbf24] mb-5" data-id="element-4">
            <Sparkles className="w-4 h-4" data-id="element-5" />
            <span className="font-bold tracking-wider uppercase text-sm" data-id="element-6">
              Material Exclusivo
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-5" data-id="element-7">
            4 <span className="text-gold-gradient" data-id="element-8">Bonus Premium</span>
          </h2>

          {/* Highlighted GRATIS banner */}
          <motion.div className="inline-flex flex-col items-center gap-2 px-6 py-4 rounded-2xl bg-gradient-to-r from-emerald-500/15 via-[#fbbf24]/20 to-emerald-500/15 border-2 border-[#fbbf24]/60 shadow-[0_0_40px_rgba(251,191,36,0.3)]" animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-9">
            <div className="flex items-center gap-2 text-white/60 text-sm" data-id="element-10">
              <Gift className="w-4 h-4 text-[#fbbf24]" data-id="element-11" />
              <span className="uppercase tracking-wider" data-id="element-12">
                Valor real <span className="line-through" data-id="element-13">$20.000</span>
              </span>
              <Gift className="w-4 h-4 text-[#fbbf24]" data-id="element-14" />
            </div>
            <p className="font-cinzel font-bold text-xl md:text-2xl" data-id="element-15">
              <span className="text-white" data-id="element-16">Hoy te lo llevas </span>
              <span className="text-gold-gradient text-2xl md:text-3xl uppercase" data-id="element-17">
                GRATIS
              </span>
            </p>
          </motion.div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto" data-id="element-18">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="glass-panel-gold rounded-2xl p-6 flex gap-5 items-start relative overflow-hidden group" data-id="element-19">
              <div className="absolute -right-10 -top-10 w-32 h-32 bg-[#fbbf24]/10 rounded-full blur-2xl" data-id="element-20" />

              <div className="w-14 h-14 shrink-0 rounded-xl bg-gradient-to-br from-[#fbbf24] to-[#f59e0b] p-[1px]" data-id="element-21">
                <div className="w-full h-full bg-[#130b29] rounded-xl flex items-center justify-center" data-id="element-22">
                  <bonus.icon className="w-7 h-7 text-[#fbbf24]" data-id="element-23" />
                </div>
              </div>

              <div className="relative z-10 flex-1 min-w-0" data-id="element-24">
                <span className="inline-flex items-center gap-1.5 text-xs font-bold text-emerald-300 px-2.5 py-0.5 mb-2 rounded-full bg-emerald-500/10 border border-emerald-500/30 whitespace-nowrap" data-id="element-25">
                  <span className="line-through opacity-60" data-id="element-26">{bonus.price}</span>
                  <span data-id="element-27">GRATIS</span>
                </span>
                <h3 className="text-lg font-cinzel font-bold text-white mb-1.5" data-id="element-28">
                  {bonus.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-29">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}